import { render, staticRenderFns } from "./EmployeeGrantsTable.vue?vue&type=template&id=b4152db4&"
import script from "./EmployeeGrantsTable.vue?vue&type=script&lang=js&"
export * from "./EmployeeGrantsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports